import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {QuestionsDetailsComponent} from './questions-details.component';

const routes: Routes = [
  {path: 'questions/details', component: QuestionsDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class QuestionsDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/questions/questions-details/questions-details-routing.module.ts